import React from "react";
import { FaHandsHelping } from "react-icons/fa";

function Volunteer() {
  return (
    <section style={styles.container}>
      <h1>Become a Volunteer</h1>

      <img
        src="https://plus.unsplash.com/premium_photo-1723921267251-120560d6ab71?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        alt="volunteer"
        style={styles.image}
        loading="lazy"
      />

      <p>
        Join Unblemished Advocacy and be part of a movement creating real impact
        in communities. Your time and skills can change lives.
      </p>

      <a
        href="https://docs.google.com/forms/d/1BmkKEBtE_ic9013uOljeZplVs8ejc147TO5dUHGWdnA/viewform"
        target="_blank"
        rel="noreferrer"
      >
        <button
          style={styles.btn}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <FaHandsHelping style={{ marginRight: "8px" }} /> Register Now
        </button>
      </a>
    </section>
  );
}

const styles = {
  container: {
    textAlign: "center",
    padding: "80px 20px"
  },
  image: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "10px",
    margin: "20px 0"
  },
  btn: {
    padding: "12px 20px",
    background: "#19195f",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "transform 0.3s, background 0.3s"
  }
};

export default Volunteer;